import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_pvex8xjvw3: FaireBrandEntity = {
  token: "b_pvex8xjvw3",
  type: "brand",
  name: "Granado Rio de Janeiro",
  avatarUrl:
    "https://cdn.faire.com/fastly/70b2a5afff5f676d9a7f1334da65c423ce392a7998b73a1d323a286ad72a1642.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/70b2a5afff5f676d9a7f1334da65c423ce392a7998b73a1d323a286ad72a1642.jpeg",
  minimumOrderDollars: 500,
  meta: {
    source: "api",
    importedAt: "2026-04-06T00:00:00.000Z",
    importedBy: "entity-db-cli",
  },
};
